import { APP_CONFIG } from './../../app/app.config';
import { InvitacionesService } from "./../../services/invitacion/invitacion.service";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, ToastController, LoadingController, AlertController, Loading, MenuController, Platform} from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";

@IonicPage({
  segment: 'activate/:codigo'
})
@Component({
  selector: "page-activate",
  templateUrl: "activate.html"
})
export class ActivatePage {
  code: string;
  
  loading: Loading;
  isIOS: boolean = false;
  
  constructor(
    protected platform: Platform,
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public translateService: TranslateService,
    public navParams: NavParams,
    private menu: MenuController,
    private is: InvitacionesService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController
  ) {
    // this.translateService.get('INVALID_CODE').subscribe(value => this.invalid_code = value);
    // this.translateService.get('INVALID_CODE_DESC').subscribe(value => this.invalid_code_Desc = value);
    // this.translateService.get('INVALID_CODE_ACTIVATION').subscribe(value => this.activateErrorString = value);
    // this.translateService.get('INVALID_SESSION').subscribe(value => this.invalid_session = value);
    // this.translateService.get('INVALID_SESSION_DESC').subscribe(value => this.invalid_session_Desc = value);
    
    if (this.navParams.get("codigo")) {
      this.code = this.navParams.get("codigo");
    }


    this.platform.ready().then(() => {
      if(this.platform.is("ios")) {
        this.isIOS = true;
      }
    });

    //this.code = "NMU@SBT";
  }

  sanitizeCode() {
    this.code = this.code.replace('https://apptoin.com/activate/', '');
  }
   doActivate() {
    

    this.translateService.get(["ACTIVATING_INVITATION"]).subscribe(value => {
      this.loading = this.loadingCtrl.create({
        spinner: "crescent",
        content: value["ACTIVATING_INVITATION"]
      });
      this.loading.present();
    });  
    APP_CONFIG.log("entra", this.loading);


    this.is
      .getInvitacionByCodigo( this.code)
      .subscribe(invitation => {
        APP_CONFIG.log("invitation", invitation);

        if (invitation["error"]) {
        APP_CONFIG.log("invitation[\"error\"]", invitation["error"]);

          this.loading.dismiss().then(() => {}, () => {});
          //mostrar error
          try {
            this.translateService.get(["ERROR_TITLE", invitation["error"]]).subscribe(value => {
              let alert = this.alertCtrl.create({
                title: value["ERROR_TITLE"],
                subTitle: value[invitation["error"]] || invitation["error"],
                buttons: ['OK'],
              });
              alert.present(); 
            });              
  
          }
          catch(e) {
            APP_CONFIG.error(e);
          }
          
        } else {
          APP_CONFIG.log("exito, temporal");
          if(window.localStorage["uid"]) {
            //asociar usuario
            this.is.setInvitacionUsuario(window.localStorage["uid"], window.localStorage["sid"], this.code).subscribe((asociacion)=> {
              this.loading.dismiss().then(() => {}, () => {});
              APP_CONFIG.log("asociacion", asociacion);
              
              if (asociacion["error"]) {
                this.translateService.get([asociacion["error"]]).subscribe(value => {
                  let alerta = this.alertCtrl.create({
                    title: '',
                    subTitle: value[asociacion["error"]] || asociacion["error"],
                    buttons: ['OK'],
                  });
                  alerta.present();
                });   
              }
              else {
                this.navCtrl.setRoot('HomePage');
              }
            })
          } else {
            //mostrar pantalla de alta
            APP_CONFIG.log("new user");
            
            this.loading.dismiss().then(() => {}, () => {});
            this.navCtrl.push("New_UserPage", { codigo : this.code });
          }
        }
      });
    
  }


  ionViewDidLoad() {
  }


  ionViewDidEnter() {
    this.menu.swipeEnable(false);
  }

  ionViewWillLeave() {
    this.menu.swipeEnable(true);
  }

  goBack() {
    if(this.navCtrl.canGoBack()) {
      this.navCtrl.pop();
    }
    else {
      if(window.localStorage["uid"]) {
        this.navCtrl.goToRoot({});
      }
      else
      {      
        this.navCtrl.setRoot("WelcomePage");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/activate/activate.ts